var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"editor "},[_c('button',{on:{"click":_vm.genCode}},[_vm._v("code gen")])])}
var staticRenderFns = []

export { render, staticRenderFns }